module.exports = __webpack_public_path__ + "img/speedometer-01.5ba70895.svg";